(function () {
  'use strict';

  function createWorkflowController($state,
    workflowConfigurationData, entity, workflowDataService) {
      var vm = this;
      vm.entity = entity;
      vm.configuration = workflowConfigurationData;
      vm.viewModel = {};
      vm.errors = [];
      vm.workflowIconStyle = vm.configuration.IconFileName ?
      "background:url('/images/icons/" + vm.configuration.IconFileName +
      "');background-repeat: no-repeat;background-position: center" :
      "";

      console.log($state.params);
      vm.submit = function submit() {
        vm.hideButtons = true;
        if (vm.entity) {
          workflowDataService.createWorkflowForEntity(vm.entity.Id, vm.viewModel,
            $state.params.t)
            .then(function (response) {
              if (response.isError) {
                vm.errors = response.Errors;
                vm.hideButtons = false;
              }
              else {
                $state.go('workflow', { workflowId: response.WorkflowId.split('/')[1] });
              }
            });
        }
        else {
          workflowDataService.createWorkflow(vm.viewModel, $state.params.t)
            .then(function (response) {
              if (response.isError) {
                vm.errors = response.Errors;
                vm.hideButtons = false;
              }
              else {
                $state.go('workflow', { workflowId: response.WorkflowId.split('/')[1] });
              }
            });
        }
      };

      vm.goBack = function () {
        $state.go('dashboard');
      }
  }

  createWorkflowController.$inject = ['$state', 'workflowConfigurationData', 'entity', 'workflowDataService'
  ];

  angular.module('ecap.workflow').controller('createWorkflowController', createWorkflowController);
})();